module.exports = {
  INSUFFICIENT_MEM: "InsufficientMemory",
  INSUFFICIENT_CPU: "InsufficientCpus",
  INSUFFICIENT_DISK: "InsufficientDisk",
  INSUFFICIENT_PORTS: "InsufficientPorts",
  UNFULFILLED_CONSTRAINT: "UnfulfilledConstraint",
  UNFULFILLED_ROLE: "UnfulfilledRole"
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/DeclinedOffersReasons.js